import { MappedClass, MappedProperty } from '@h5s/util-object';
import { BackendVersionInfo } from './backend-version-info';

@MappedClass()
export class VersionResponse {
  @MappedProperty()
  backend: BackendVersionInfo;
}
